import { Type, type Static } from '@sinclair/typebox';
import {
  defineSchema,
  SystemFields,
  StringField,
  TextField,
  BooleanField,
  IntegerField,
} from '@ayocore/platform/common/helpers/schema-types';

import { name as moduleName } from '../module.json';

/**
 * Справочник причин отказа / отмены.
 *
 * Универсальный справочник CRM — используется для:
 * - закрытия лидов в статусе LOST (lead.lost_reason_id),
 * - отмены сделок в негативных финальных статусах (deal.cancel_reason_id).
 *
 * Конкретные значения регистрируются через defineLostReason().
 * Базовый набор регистрируется в crm/server/setup.ts.
 * Инстансы могут расширять набор своими записями.
 */
export const LostReasonSchema = Type.Object({
  ...SystemFields,

  code: StringField({
    title: 'Код причины',
    minLength: 1,
    maxLength: 100,
    description: 'Уникальный код причины (NO_NEED, TOO_EXPENSIVE и т.п.)',
  }),

  name: StringField({
    title: 'Название причины',
    minLength: 1,
    maxLength: 255,
    description: 'Человекочитаемое название причины отказа.',
  }),

  description: TextField({
    title: 'Описание',
    nullable: true,
    description: 'Дополнительное описание причины.',
  }),

  sort_order: IntegerField({
    title: 'Порядок сортировки',
    default: 0,
    description: 'Порядок отображения в списке.',
  }),

  is_active: BooleanField({
    title: 'Активна',
    default: true,
    description: 'Доступна для выбора при закрытии лида/сделки.',
  }),
});

export type LostReason = Static<typeof LostReasonSchema>;

export default defineSchema({
  moduleName,
  tableName: 'lost_reasons',
  schema: LostReasonSchema,
  additionalIndexes: [{ columns: ['code'], unique: true }, 'is_active', 'sort_order'],
  dependencies: [],
});
